/**
 * SP2 §6 — the hardwired per-transaction balancer. Pure; integer-cents only.
 * One function, two homes: the server enforces with it (reconcile, Task 7)
 * and SP3's station recomputes live with the SAME function — no drift.
 */
/** Strict money parse → integer cents, or null. Strips currency symbols,
 *  spaces, and thousands commas; accepts 0–2 decimals; rejects negatives
 *  (v1 — SP2 §6), junk, and >2 decimals. NO float arithmetic. */
export function parseAmountToCents(raw) {
    if (raw == null)
        return null;
    const s = String(raw).trim().replace(/[$\s]/g, '').replace(/,/g, '');
    if (s === '')
        return null;
    const m = /^(\d+)(?:\.(\d{1,2}))?$/.exec(s);
    if (!m)
        return null;
    const whole = m[1];
    const frac = (m[2] ?? '').padEnd(2, '0');
    return Number(whole) * 100 + (frac ? Number(frac) : 0);
}
/** Inverse of parseAmountToCents: integer cents → the field's keyable amount
 *  string ("1234.56" — no thousands separators, always 2 decimals, no currency
 *  symbol). Integer math only (NO float division) so the round-trip through
 *  parseAmountToCents is exact. The ONE cents→string convention — worker
 *  pre-fill and station keying aids must both import this, never re-derive. */
export function centsToAmountString(cents) {
    const negative = cents < 0;
    const abs = Math.abs(Math.trunc(cents));
    const whole = Math.floor(abs / 100);
    const frac = String(abs % 100).padStart(2, "0");
    return `${negative ? "-" : ""}${whole}.${frac}`;
}
export function computeBalanceSnapshot(input) {
    const all = [...input.payments, ...input.coupons];
    const indeterminate = all.some((r) => r.cents === null);
    const sum = (rs) => rs.reduce((acc, r) => acc + (r.cents ?? 0), 0);
    const paymentTotalCents = sum(input.payments);
    const appliedTotalCents = sum(input.coupons);
    const deltaCents = paymentTotalCents - appliedTotalCents;
    const verdict = indeterminate
        ? 'indeterminate'
        : Math.abs(deltaCents) <= input.toleranceCents
            ? 'balanced'
            : 'imbalanced';
    const source = all.length > 0 && all.every((r) => r.source === 'keyed') ? 'keyed' : 'ocr';
    return {
        paymentTotalCents,
        appliedTotalCents,
        deltaCents,
        verdict,
        source,
        computedAt: (input.now ?? new Date()).toISOString(),
    };
}
//# sourceMappingURL=balance.js.map